import type { IconProps } from './IconProps';

export const IndeterminateIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 10 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 10}
    height={props.height ?? 2}
    {...props}
  >
    <path
      d="M1 1H9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
